<p class="modal-title">Admin: @if (isAdd()) {Add} @else {Edit} Item</p>
<div class="body flex flex-col">
  <form [formGroup]="itemForm" (ngSubmit)="onSubmit()" #itemFormRef="ngForm">
    <app-form-field
      [label]="'Name'"
      [formControl]="name"
      [errorType]="'outline'"
      [id]="'name'"
      [submitting]="false"
      [placeholder]="'Enter Name...'"
      [error]="
        !name.valid && itemFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="
        'Price with no decimal ' +
        '(' +
        adminItemsService.coefficient +
        ' = 1$)'
      "
      [formControl]="price"
      [errorType]="'outline'"
      [id]="'price'"
      [submitting]="false"
      [placeholder]="'Enter Price...'"
      [type]="'number'"
      [error]="
        !price.valid && itemFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <button class="button button--style-yellow h-32 padding-x-12" type="submit">
      @if (isAdd()) {Add} @else {Edit} Item
    </button>
  </form>
</div>
